<template>
  <div class="login">
    <el-form
      ref="loginRef"
      :model="loginForm"
      :rules="loginRules"
      autocomplete="off"
      class="login-form"
    >
      <div id="lang-select">
        <YlI18nSelect class="login-i18n" />
      </div>
      <h3 class="title">
        <img
          v-if="langType === 'CN'"
          src="~@/assets/login/logo_cn.png"
          alt="LOGO"
        />
        <img v-else src="~@/assets/login/logo_en.png" alt="LOGO" />
        <img class="sign" src="~@/assets/login/fcs.png" />
      </h3>
      <el-form-item prop="account">
        <el-input
          v-model="loginForm.account"
          type="text"
          size="large"
          clearable
          auto-complete="off"
          :placeholder="$t('账号')"
        >
          <template #prefix
            ><svg-icon icon-class="user" class="el-input__icon input-icon"
          /></template>
        </el-input>
      </el-form-item>
      <el-form-item prop="password" class="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          size="large"
          autocomplete="new-password"
          :placeholder="$t('密码')"
          show-password
          @keyup.enter="handleLogin(null)"
        >
          <template #prefix
            ><svg-icon icon-class="password" class="el-input__icon input-icon"
          /></template>
        </el-input>
      </el-form-item>
      <div class="login-opt">
        <el-checkbox
          v-model="loginForm.rememberMe"
          style="margin: 0 0 40px 0"
          >{{ $t('记住密码') }}</el-checkbox
        >
        <span class="login-opt-ftpwd" @click="forgetPwd">
          {{ $t('忘记密码') }}
        </span>
      </div>
      <el-form-item style="width: 100%">
        <el-button
          class="login-btn"
          :loading="loading"
          size="large"
          type="primary"
          @click.prevent="handleLogin(null)"
        >
          <span v-if="!loading">{{ $t('登 录') }}</span>
          <span v-else>{{ $t('登 录 中...') }}</span>
        </el-button>
        <div style="float: right" v-if="register">
          <router-link class="link-type" :to="'/register'">{{
            $t('立即注册')
          }}</router-link>
        </div>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <span>
        {{ $t('Copyright © 2024 云路科技.All Rights Reserved') }}
      </span>
    </div>
  </div>
</template>

<script setup>
import md5 from 'js-md5';
import { useRouter } from 'vue-router';
import {
  ref,
  getCurrentInstance,
  onMounted
  // toRaw,
  // onBeforeUnmount
} from 'vue';

import Cookies from 'js-cookie';
import { encrypt, decrypt } from '@/utils/jsencrypt';
import { useUserStoreHook } from '@/store/modules/user';
import { useBaseStoreHook } from '@/store/modules/base';
import { usePermissionStoreHook } from '@/store/modules/permission';
import { handleAsyncRoutes } from '@/router/utils';
import { useLayout } from '@/layout/hooks/useLayout';
import { $t } from '@/plugins/i18n';
import { getInfo } from '@/api/user';
import { RULES } from '@/utils/validators';
// import { constantsRouter } from '@/router/constants';
import { handleMenuData, filterRouterPath } from '@/router/index';
import { ElMessage } from 'element-plus';
import { ACCOUNT_INFO_NAMES } from '@/utils/const';
import { reqCaptchaSwitch } from '@/api/common';

const cjs_account = ACCOUNT_INFO_NAMES['account'];
const cjs_password = ACCOUNT_INFO_NAMES['password'];
const cjs_rememberMe = ACCOUNT_INFO_NAMES['rememberMe'];

const router = useRouter();
const { proxy } = getCurrentInstance();

const captchaAppId = '189987023';
const captcha = ref(null);
const txVeriryCodeSwitchStatus = ref(true);
let txVeriryTimeState = null;
const { initStorage } = useLayout();
initStorage();

const langType = localStorage.getItem('lang') || 'CN';

const loginForm = ref({
  account: '',
  password: '',
  rememberMe: false,
  code: '',
  uuid: ''
});

// 规则验证--必填
const checkPwd = (rule, value, callback) => {
  if (!value) {
    return callback(new Error($t('请输入密码')));
  }
  callback();
};
const loginRules = {
  account: [RULES.required],
  password: [
    RULES.required,
    { validator: checkPwd, trigger: ['blur', 'change'] }
  ]
};

// const codeUrl = ref('');
const loading = ref(false);
// 验证码开关
// const captchaEnabled = ref(true);
// 注册开关
const register = ref(false);
// const redirect = ref(undefined);
// chenhaici123    123456
onMounted(() => {
  initTencentCaptcha();
});

function setAccountToCookie() {
  // 勾选了需要记住密码设置在 cookie 中设置记住用户名和密码
  if (loginForm.value.rememberMe) {
    Cookies.set(cjs_account, loginForm.value.account, {
      expires: 30
    });
    Cookies.set(cjs_password, encrypt(loginForm.value.password), {
      expires: 30
    });
    Cookies.set(cjs_rememberMe, loginForm.value.rememberMe, {
      expires: 30
    });
  } else {
    // 否则移除
    Cookies.remove(cjs_account);
    Cookies.remove(cjs_password);
    Cookies.remove(cjs_rememberMe);
  }
}
function handleLogin(captchInfo = {}) {
  proxy.$refs.loginRef.validate(valid => {
    if (valid) {
      if (txVeriryCodeSwitchStatus.value && !captchInfo) {
        // return captcha.value.show();
        try {
          captcha.value.show();
        } catch (error) {
          loadErrorCallback();
        }
        return;
      }
      // const { ticket, randstr } = captchInfo;
      loading.value = true;
      // console.log(loginForm.value, 'loginForm.value');
      const { account, password } = loginForm.value;
      const params = { account, password: md5(password), ...captchInfo };
      // 调用action的登录方法
      try {
        // 调用action的登录方法
        useUserStoreHook()
          .loginByUsername(params)
          .then(async () => {
            clearInterval(txVeriryTimeState);
            setAccountToCookie();
            // 获取用户信息+资源权限
            const { data } = await getInfo();
            if (!data.permissionMenus || !data.permissionMenus.length) {
              // 无权限 自动退出
              usePermissionStoreHook().clearAllCachePage();
              useUserStoreHook().logOut();
              ElMessage($t('该用户无权限, 禁止登陆系统'), {
                type: 'error',
                duration: 5 * 1000
              });
              window.location.reload();
              return;
            }
            useUserStoreHook().SET_ROLETYPE(data.loginUserRoleType);
            const menu = filterRouterPath(data.permissionMenus);
            const newMenu = handleMenuData(menu);
            console.log('menu: ', newMenu);
            handleAsyncRoutes(newMenu).then(() => {
              useBaseStoreHook().setDictList();
              router.push('/welcome');
            });
          })
          .catch(() => {
            loading.value = false;
          });
      } catch (e) {
        console.log(e, 'useUserStoreHookuseUserStoreHookuseUserStoreHook');
      }
    }
  });
}

function getCookie() {
  const account = Cookies.get(cjs_account);
  const password = Cookies.get(cjs_password);
  if (password) {
    loginForm.value = {
      account: account === undefined ? loginForm.value.account : account,
      password:
        password === undefined ? loginForm.value.password : decrypt(password),
      rememberMe: true
    };
  }
}

getCookie();

const initTencentCaptcha = () => {
  const LanguageList = { EN: 'en', CN: 'zh-cn', PH: 'fil' };
  // 初始化tx验证码
  // 生成实例对象
  captcha.value = new window.TencentCaptcha(
    captchaAppId,
    tencentCaptchaCallback,
    { userLanguage: LanguageList[localStorage.getItem('lang') || 'CN'] }
  );
};
const tencentCaptchaCallback = (res = {}) => {
  // 验证回调
  // 验证成功，返回对象
  if (res.ret === 0) {
    // 解构参数
    // ticket票据 randstr随机字符串
    const { ticket, randstr } = res;
    // 调用登陆
    handleLogin({ ticket, randstr });
    return res;
  }
  // 验证不成功
  return null;
};
// 定义验证码js加载错误处理函数
function loadErrorCallback() {
  // 生成容灾票据或自行做其它处理
  const ticket =
    'terror_1001_' +
    captchaAppId +
    '_' +
    Math.floor(new Date().getTime() / 1000);
  tencentCaptchaCallback({
    ret: 0,
    randstr: '@' + Math.random().toString(36).substr(2),
    ticket,
    errorCode: 1001,
    errorMessage: 'jsload_error'
  });
}
function forgetPwd() {
  ElMessage.warning($t('请联系管理员!'));
}

const setIntervalTxVeriry = () => {
  clearInterval(txVeriryTimeState);
  txVeriryTimeState = setInterval(() => {
    getCaptchaStatus();
  }, 30 * 1000);
};

async function getCaptchaStatus() {
  try {
    const { code, data, msg } = await reqCaptchaSwitch();
    if (code === 1) {
      txVeriryCodeSwitchStatus.value = data;
    } else {
      console.warn('getxVeriryCodeSwitchStatus::warn', code, msg);
    }
  } catch (error) {
    console.error('getxVeriryCodeSwitchStatus::error', error);
  }
}
getCaptchaStatus();
setIntervalTxVeriry();
</script>

<style lang="scss">
#lang-select {
  display: flex;
  justify-content: flex-end;
  .login-i18n {
    width: 100px;
    .el-select-dropdown__item {
      width: 100%;
      padding: 0 10px 0 10px;
      &:hover {
        background: #f0f4ff !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.login {
  background: url('@/assets/login/bg.jpeg');
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  background-size: cover;
  min-width: 1200px;
  padding-right: 10%;
  user-select: none;
}
.title {
  margin: 30px auto 52px;
  text-align: center;
  font-size: 40px;
  color: #222;
  img {
    height: 40px;
    margin: 0 auto;
  }
  .sign {
    height: 18px;
    margin-top: 20px;
  }
}
.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 480px;
  padding: 50px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  .lm-i18n {
    width: 84px;
  }
  .login-opt {
    .login-opt-ftpwd {
      float: right;
      font-size: 12px;
      color: #fb4400;
      cursor: pointer;
    }
  }
  .login-btn {
    width: 100%;
    height: 50px;
    border-radius: 5px !important;
    //background: #0142fe;
    cursor: pointer !important;
    background-image: linear-gradient(
      to right,
      #0142fe 0%,
      #3e6cdf 51%,
      #0142fe 100%
    );
    transition: 0.5s;
    background-size: 200% auto;
    &:hover {
      background-position: right center !important; /* change the direction of the change here */
      color: #fff !important;
      text-decoration: none !important;
    }
  }
  .el-form-item {
    margin-bottom: 32px;
    &.password {
      // margin-bottom: 12px;
    }
  }
  .el-input {
    height: 48px;
    input {
      height: 48px;
    }
  }
  .el-input__wrapper.is-focus {
    box-shadow: 0 0 0 1px red !important;
    svg {
      color: #0142fe;
    }
  }
  .input-icon {
    height: 49px;
    width: 14px;
    margin-left: 0px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 40px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 40px;
  padding-left: 12px;
}
</style>
